<div style="margin: 10px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer">
            <span   [ngClass]="menu_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='1'">
        <div style="display: flex;">
            
            <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 2%;margin-right: 1%;" [(ngModel)]="search_sms" (change)="default();init_list()">
                <option *ngFor="let item of sms_list" [ngValue]="item.id">{{item.name}}</option>
            </select>
            <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 2%;margin-right: 1%;" [(ngModel)]="search_project" (change)="default();init_list()">
                <option *ngFor="let item of project_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <div style="margin-right: 2%">
                <select class="form-control"
                    style="width: 160px;display: inline-block;"
                    [(ngModel)]="data_view_list_act"
                    (change)="disable();init_list()"
                >            
                    <option *ngFor="let item of data_view_list" [ngValue]="item.id">{{item.name}}</option>
                </select>
            </div>

            <div class="dateSetting" *ngIf="data_view_list_act == '2'">
                <input type="text" class="form-control"  [(ngModel)] ="monthRange" style="width: 260px;display: inline-block;margin-right: 16px;" (click)="openMonth()">
                <month-picker *ngIf="openMonthdata" (monthRangeSelected)="disable();logRange($event)" (status)="closeMonth()"></month-picker>
            </div>

            <div class="datearea"  *ngIf="data_view_list_act == '1'">
                <input type="text"
                *ngIf="time"
                class="form-control"
                 ngxDaterangepickerMd
                 [(ngModel)]="time"
                 [autoApply]="true"
                [ranges]="ranges" [alwaysShowCalendars]="true"
                [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                [opens]="'right'"
                [minDate]="time.minDate"
                [maxDate]='time.maxDate'
                (change)="disable();onRangeSelected(1,$event)"
                (blur)="onDateTyped($event)"
                style="width: 260px;display: inline-block;margin-right: 16px;"
                >
            </div>
        </div>
        <div style="margin: 30px 0 0 10px;" *ngIf="data?.length > 0">
            <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions" style="display: block;width: 70%;"></highcharts-chart>
        </div>

        <div class="card-body" style="font-size: larger;" *ngIf="data?.length > 0">
            <div  class="card-text top_info_num">
                總使用數：{{all_num | number}}
            </div>
            <div  class="card-text top_info_num">
                專案使用數：{{chartTotal | number}}
            </div>
            <div class="card-text top_info_num">
                總平均每日使用數：{{ roundedAllAverage | number }}
            </div>
            <div class="card-text top_info_num">
                專案平均每日使用數：{{ roundedAverage | number }}
            </div>
            <div class="card-text top_info_num">
                現有簡訊點數：{{ sms_point | number }}
            </div>
            <div class="card-text top_info_num">
                可用天數預估：{{ roundedAveragesms | number }}
            </div>
        </div>
       
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">  
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'project_id'">
                    <div [ngSwitch]="post.val.project_id">
                        <div *ngSwitchCase="1">youbuy</div>
                        <div *ngSwitchCase="2">voxy</div>
                        <div *ngSwitchCase="5">social</div>
                        <div *ngSwitchCase="8">sport_lottery</div>
                    </div>
                </div>

                <div *ngIf="post.key == 'used_type'">
                    <div *ngIf="post.val.project_id == 2" [ngSwitch]="post.val.used_type">
                        <div *ngSwitchCase="1">登入</div>
                        <div *ngSwitchCase="2">未完成回歸</div>
                        <div *ngSwitchCase="3">生日禮物</div>
                        <div *ngSwitchCase="4">老友回歸</div>
                        <div *ngSwitchCase="5">後台操作一次性簡訊</div>
                        <div *ngSwitchDefault>刪除帳號</div>
                    </div>
                    
                    <div *ngIf="post.val.project_id != 2">
                        <div>一般</div>
                    </div>

                </div>
            </ng-template>  
        </app-table-v2>

    </div>
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>
</div>
<app-spinner [loading]="loading"></app-spinner>


